import BrandBanner from "@image/piperunner-banner.svg";
import { type GetSocialLinksResponse, isDefined } from "@piperunner-cms/types/v1";
import Footer from "@repo/ui/components/layout/Footer";
import { cn } from "@repo/ui/lib/utils";
import Link from "next/link";
import {
  FaDiscord as DiscordIcon,
  FaGithub as GithubIcon,
  FaInstagram as InstagramIcon,
  FaLinkedin as LinkedinIcon,
  FaSteam as SteamIcon,
  FaTwitter as TwitterIcon,
  FaGlobeAmericas as WebsiteIcon,
  FaYoutube as YoutubeIcon,
} from "react-icons/fa";
import { useSocialLinks } from "@/queries/essentials.queries";
import styles from "../AppShell.module.css";

const IconMap: Record<keyof GetSocialLinksResponse["latest"], React.ReactNode> = {
  linkedin: <LinkedinIcon size={24} className="fill-blue-600" />,
  github: <GithubIcon size={24} className="fill-gray-900" />,
  twitter: <TwitterIcon size={24} className="fill-blue-500" />,
  website: <WebsiteIcon size={24} className="fill-green-700" />,
  discord: <DiscordIcon size={24} className="fill-blue-700" />,
  youtube: <YoutubeIcon size={24} className="fill-red-600" />,
  instagram: <InstagramIcon size={24} className="fill-pink-500" />,
  steam: <SteamIcon size={24} className="fill-black" />,
};

export const AppFooter = () => {
  const { data: socialLinks } = useSocialLinks();

  return (
    <Footer className="z-[3]">
      <Footer.PrimaryItem className="flex items-center justify-center">
        <div className={cn(styles.footerText, "w-3/4")}>
          <BrandBanner />
        </div>
      </Footer.PrimaryItem>
      <Footer.TertiaryItem className="bg-sidebar/30 flex justify-center w-full px-6 py-3 gap-x-6 gap-y-6 flex-wrap">
        {socialLinks.latest &&
          Object.entries(socialLinks.latest)
            .filter(([_, url]) => isDefined(url))
            .filter(([key, _]) => IconMap[key as keyof GetSocialLinksResponse["latest"]])
            .map(([key, url]) => {
              const Icon = IconMap[key as keyof GetSocialLinksResponse["latest"]];
              return (
                <Link
                  key={key}
                  // biome-ignore lint/style/noNonNullAssertion: <explanation>
                  href={url!}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-foreground hover:text-foreground/70"
                >
                  {Icon}
                </Link>
              );
            })}
      </Footer.TertiaryItem>
      <Footer.SecondaryItem className="flex flex-col items-center justify-center gap-2 font-sans">
        <a
          href={`mailto:${socialLinks.latest?.email}?subject=%20MESSAGE%20FROM%20A%20TRAVELLER%20OF%20THE%20WIRE`}
          className="text-sm underline text-foreground hover:text-foreground/70"
        >
          {socialLinks.latest?.email}
        </a>
        <div>
          <Link href={"/privacy-policy"}>
            <span className="underline text-accent-base">privacy-policy</span>
          </Link>
        </div>
        <span className="text-sm font-mono">Made with 💜 by PIPE RUNNER LAB</span>
      </Footer.SecondaryItem>
    </Footer>
  );
};
